import { motion } from 'motion/react';
import { Check } from 'lucide-react';
import {
  ACCOUNT_TYPE_OPTIONS,
  type AccountType,
} from '../lib/onboardingProfile';
import { ONBOARDING_ROLE_ICONS } from './icons/onboarding';
import { onboardingClasses, onboardingEase, onboardingMotion } from '../lib/onboardingTheme';
import { cn } from '../lib/utils';

interface RoleSelectCardsProps {
  value?: AccountType | string;
  onSelect: (accountType: AccountType) => void;
}

export default function RoleSelectCards({ value, onSelect }: RoleSelectCardsProps) {
  return (
    <div className="mx-auto grid w-full max-w-2xl grid-cols-1 gap-3 sm:grid-cols-2">
      {ACCOUNT_TYPE_OPTIONS.map((opt, idx) => {
        const Icon = ONBOARDING_ROLE_ICONS[opt.icon];
        const isSelected = value === opt.id;

        return (
          <motion.button
            key={opt.id}
            type="button"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: onboardingMotion.duration,
              delay: idx * onboardingMotion.stagger,
              ease: onboardingEase,
            }}
            onClick={() => onSelect(opt.id)}
            className={cn(
              'group flex flex-col items-start p-4 text-left md:p-5',
              onboardingClasses.glassCard,
              onboardingClasses.glassCardHover,
              isSelected && onboardingClasses.glassCardSelected,
              'rounded-[22px]',
            )}
          >
            <div className="mb-3 flex w-full items-start justify-between gap-2">
              <div
                className={cn(
                  'flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.06] backdrop-blur-md',
                  isSelected && onboardingClasses.iconRingSelected,
                )}
              >
                <Icon
                  className={cn(
                    'h-5 w-5 transition-colors duration-300 md:h-6 md:w-6',
                    isSelected ? 'text-[#E8EDF4]' : 'text-[#C5CED9] group-hover:text-[#E8EDF4]',
                  )}
                />
              </div>
              {isSelected && (
                <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-white/25 bg-white/10 backdrop-blur-sm">
                  <Check className="h-3 w-3 text-[#E8EDF4]" strokeWidth={2} />
                </div>
              )}
            </div>
            <h4 className="text-base font-medium tracking-[-0.01em] text-[#F4F6F8] md:text-lg">
              {opt.label}
            </h4>
            <p className="mt-1 text-xs leading-snug text-[#8B95A8] md:text-sm">{opt.description}</p>
          </motion.button>
        );
      })}
    </div>
  );
}

